import React, { useState, useEffect, useCallback } from 'react';
import locales from '../../../content.json';
import arrowImg from '../../everydoggyV2/brandButton/img/img1.png';
import s from './index.module.scss';

const StickyGetMyPlan = () => {
  const [visible, setVisible] = useState(true);
  const lang =
    typeof window !== 'undefined' && window.userLang && locales[window.userLang]
      ? window.userLang
      : 'en';

  useEffect(() => {
    const firstOffer = document.querySelector('[data-offer-wrapper]');
    if (!firstOffer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(false);
        } else if (entry.boundingClientRect.top > 0) {
          // first offer is below viewport — user scrolled back up
          setVisible(true);
        }
        // first offer is above viewport (scrolled past) — stay hidden
      },
      { threshold: 0 },
    );

    observer.observe(firstOffer);

    return () => observer.disconnect();
  }, []);

  const handleClick = useCallback(() => {
    const firstOffer = document.querySelector('[data-offer-wrapper]');
    if (!firstOffer) return;

    // The app shell can scroll via #root and/or .app; let the browser scroll
    // whichever element actually owns the scroll. scroll-margin-top on the offer
    // keeps it clear of the sticky timer (see .offerWrapper).
    firstOffer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  if (!visible) return null;

  return (
    <div className={s.wrapper}>
      <button className={s.button} onClick={handleClick} type="button">
        <p>{locales[lang].get_my_plan}</p>
        <img className={s.arrow} src={arrowImg} alt="" />
      </button>
    </div>
  );
};

export default StickyGetMyPlan;
